import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileFormat',
  standalone: true,
})
export class FileFormatPipe implements PipeTransform {
  public transform(filename: string): string {
    const parts: string[] = filename.split('.');
    const ext: string | undefined = parts.length > 1 ? parts.pop() : undefined;

    return ext ? `Dateiformat: ${ext.toUpperCase()}` : '';
  }
}
